// extracted by mini-css-extract-plugin
export default {"btn":"AffiliateBusinessManager_btn__4juP6","table-container":"AffiliateBusinessManager_table-container__rpO05"};